import React, { Suspense } from "react";
import { AuthProtected } from "./AuthProtected";
import { Route, Routes } from "react-router-dom";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import { authProtectedRoutes, publicRoutes } from "./allRouter";
import LoadingSpinner from "../Components/Common/LoadingSpinner";

const VerticalLayout = React.lazy(() => import("../Layouts/index"));

/** Panel route lazy chunk — boş fallback yerine ortalı loading */
const PanelRouteFallback = () => (
 <LoadingSpinner tip="Sayfa yükleniyor…" />
);

const Index = () => {
 return (
  <Routes>
   <Route>
    {publicRoutes.map((route, idx) => {
     return (
      <Route
       path={route.path}
       element={
        <NonAuthLayout>
         <Suspense fallback={<LoadingSpinner />}>
          {route.component}
         </Suspense>
        </NonAuthLayout>
       }
       key={idx}
       exact={true}
      />
     );
    })}
   </Route>
   <Route>
    {authProtectedRoutes.map((route, idx) => {
     const template = route.template ?? true;
     return (
      <Route
       path={route.path}
       element={
        <AuthProtected role={route.role}>
         {template ? (
          <Suspense fallback={<LoadingSpinner tip="Panel yükleniyor…" />}>
           <VerticalLayout>
            <Suspense fallback={<PanelRouteFallback />}>
             {route.component}
            </Suspense>
           </VerticalLayout>
          </Suspense>
         ) : (
          <Suspense fallback={<LoadingSpinner />}>
           <div>{route.component}</div>
          </Suspense>
         )}
        </AuthProtected>
       }
       key={idx}
       exact={true}
      />
     );
    })}
   </Route>
  </Routes>
 );
};

export default Index;
